import React from 'react';
import './HomePage.css';
import parental from '../images/parental-advisory.jpg';
import 'font-awesome/css/font-awesome.min.css';


const HomePage = (props) => (
  <div className="container">
    <div className="why">
      <h1 className="title">Clean up your Spotify playlists!</h1>
      <img src={parental} alt="parental adivory logo" />
    </div>
    <p className="about">If you have younger children, you may have had the following experience. You were enjoying some new music on your Discover Weekly or New Music Friday playlist and the next thing you know the F-bomb is being dropped while your children are in earshot. I am a big fan of Spotify and have been using the service for a long time. My one complaint is that there is no way to filter out explicit content. Thousands of customers have requested a filter in the Spotify forums and they have yet to add the feature. Until this happens, Playlist Filter is the next best thing.</p>
    <section className="service">
      <div className="service_card">
        <div className="thumbnail">
          <i className="fa fa-cogs icons" />
          <h4 className="about_title">How it works</h4>
          <p className="about_description">When selecting a playlist you wish to clean, a copy of the playlist is made and (clean) is added to the playlist name. Playlist Filter analyzes the playlist and does not copy any track that is marked as explicit.</p>
        </div>
      </div>
      <div className="service_card">
        <div className="thumbnail">
        <i className="fa fa-plus icons" />
          <h4 className="about_title">Other Features</h4>
            <li>List all of your playlists</li>
            <li>Display the number of total tracks in each playlist</li>
            <li>Check a playlist to see how many songs are marked as "explicit"</li>
            <li>Clean a playlist</li>
            <li>Delete old or stale playlists</li>
        </div>
      </div>
      <div className="service_card">
        <div className="thumbnail">
          <i className="fa fa-usd icons" />
          <h4 className="about_title">Cost?</h4>
          <p className="about_description">Playlist Filter is free! Just log in with your Spotify account to get started.</p>
        </div>
      </div>
    </section>
    <section className="login">
      <a href="" className="login_button" onClick={props.login}>Login with Spotify</a>
    </section>
  </div>
);

export default HomePage;


// WEBPACK FOOTER //
// ./src/components/HomePage.js